<div *ngIf="user.roleId===1 " class="action_pb btn btn-dark btn-refresh" (click)="refresh()">
  <div class="action_reassign" >
    <div class="action_reassign_icon"></div>
  </div>
</div>
<hbo-datatable-smart *ngIf="devices$ | async as devices" [columns]="columns" [items]="devices"
  (reload)="searchDevices($event)" [typeData]="'devicesList'"
  [showFilterPanel]="true"
  [showDeviceFilters]="true"
  [showTeamFilter]="true"
  [teams_filter]="teams">
  <tbody class="table-group-divider accordion" id="accordionDevice">
    <ng-container *ngFor="let device of devicesCollection$">
      <tr class="accordion-header" data-bs-toggle="collapse"
      [attr.data-bs-target]="'#collapse-' + device.id">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + device.id"> </button></th>
        <td *ngIf="user.roleId===1">{{ device.id }}</td>
        <td>{{ device.deviceType.name }}</td>
        <td>{{ device.serialNumber }}</td>
        <td>{{ device.entity.name }}</td>
        <td>{{ device.entity.parentEntity?.name }}</td>
        <td>
          <!--<div *ngIf="device.linked" class="device-link-td" [title]="device.linked!.packages" [routerLink]="'/licenses/packages/edit/'+device.linked!.packages"><i class="bi bi-link"></i><span> {{'('+device.linked!.packages+')'}}</span></div>-->
        <div *ngIf="device.linked" class="devices-package-link">
            <div *ngFor="let devicePack of packagesLinks(device.linked!.packages ?? '')"  class="device-link-td" [title]="devicePack" [routerLink]="'/licenses/packages/edit/'+devicePack"><i class="bi bi-link"></i><span> {{'('+devicePack+')'}}</span></div>
          </div>
        </td>
        <ng-container *ngIf="user.roleId === 1 || user.roleId === 2 || user.roleId === 3">
          <td>{{ device.hardwareVersion }}</td>
          <td>{{ device.frontendSwVersion }}</td>
          <td>{{ device.backendSwVersion }}</td>
          <td>{{ device.lastActivity | date:'yyyy/MM/dd HH:mm' }}</td>
        </ng-container>
        <td><span *ngIf="user.roleId === 1">{{ device.appName }}</span></td>
      </tr>
      <tr class="row-body">
        <td [attr.colspan]="columns.length + 1" class="bg-light p-0">
          <div [id]="'collapse-' + device.id" class="accordion-collapse collapse" data-bs-parent="#accordionDevice">
            <div class="accordion-body">
              <hbo-device-actions [device]="device" (reload)="searchDevices()" [selectorVisible]="openedRow === 'collapse-' + device.id" (callback)="callback($event)"></hbo-device-actions>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!devices.data.length">
      <td [attr.colspan]="columns.length + 1" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>